import { render } from "./ButtonResetServiceData.vue?vue&type=template&id=10f393ba"
import script from "./ButtonResetServiceData.vue?vue&type=script&lang=js"
export * from "./ButtonResetServiceData.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__